import {
    AppointmentsModel,
} from 'one-card-appointments-table';

import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT,
    ADD,
    SETPATIENT,
    PUSHCANCELAPPT,
    RESETCANCELNOTIFICATION,
    PUSHCONFIRMAPPT,
    REINITONPATIENTCHANGE,
    PUSHUPDATEAPPT
} from './types';

/**
 * Redux action creator to set the list
 * of all appointments
 * @param upcomingappts list of all appointments
 * @returns action instance
 */
export const setAction = (appts: AppointmentsModel):
    Action<typeof SET, AppointmentsModel> => ({
        type: SET,
        payload: appts,
    });

/**
 * Redux action creator to set the list
 * of all appointments
 * @param patientId has patient ID
 * @returns action instance
 */
export const setSelectedPatient = (patientId: string):
    Action<typeof SETPATIENT, string> => ({
        type: SETPATIENT,
        payload: patientId,
    });


/**
 * Redux action creator to set the type
 * to appointments
 * @param apptstype 
 */
export const addAction = (apptstype: AppointmentsModel):
    Action<typeof ADD, AppointmentsModel> => ({
        type: ADD,
        payload: apptstype,
    });

/**
 * Re-initialize the state
 * @returns action instance 
 */
export const reinitAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });

/**
 * Re-initialize the state
 * @returns action instance 
 */
export const reInitOnPatientChangeAction = ():
    Action<typeof REINITONPATIENTCHANGE> => ({
        type: REINITONPATIENTCHANGE,
    });

/**
 * Push Cancel Appt to state
 * @returns action instance 
 */
export const pushCancelAppt = (payload:any):
    Action<typeof PUSHCANCELAPPT> => ({
        type: PUSHCANCELAPPT,
        payload: payload
    });
    
/**
 * Redux action creator to reset the Cancel Appt Notification
 * to appointments
 * @param apptnotification 
 */
export const resetCancelApptNotification = (apptnotification: object):
    Action<typeof RESETCANCELNOTIFICATION, object> => ({
        type: RESETCANCELNOTIFICATION,
        payload: apptnotification,
    });    


/**
 * Push Confirm Appt to state
 * @returns action instance 
 */
 export const pushConfirmAppt = (payload:any):
 Action<typeof PUSHCONFIRMAPPT> => ({
     type: PUSHCONFIRMAPPT,
     payload: payload
 });
/**
 * Push Update Appt to state
 * @returns action instance 
 */
 export const pushUpdateAppt = (payload:any):
 Action<typeof PUSHUPDATEAPPT> => ({
     type: PUSHUPDATEAPPT,
     payload: payload
 });
/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof setSelectedPatient> |
    ReturnType<typeof addAction> |
    ReturnType<typeof pushCancelAppt> |
    ReturnType<typeof resetCancelApptNotification> |
    ReturnType<typeof reinitAction> |
    ReturnType<typeof pushConfirmAppt> |
    ReturnType<typeof reInitOnPatientChangeAction> |
    ReturnType<typeof pushUpdateAppt>;